import React, { FC, PropsWithChildren } from 'react';
import { Card } from '@mofid-securities/uikit';
import { ILayoutAnalytics } from '@/layouts/layout.types';
import { HamiBalanceSlide } from '@/components/BalanceSlide';
import Hidden from '@/components/Hidden';
import { ThemeHeader } from '@/components/ThemeHeader';
import CardBackHeader, {
  ICardBackHeaderProps,
} from './components/CardBackHeader';
import { classnames } from '@/utils/classnames';

export interface ISubPageLayoutProps
  extends Pick<
    ICardBackHeaderProps,
    | 'showSupportButtonOnMobile'
    | 'showSupportButtonOnDesktop'
    | 'isHeaderSticky'
    | 'hasCardHeaderBorder'
    | 'title'
    | 'hintComponent'
    | 'hiddenStoryContainer'
  > {
  showHamiBalance?: boolean;
  hasPaddingX?: boolean;
  isContentFixed?: boolean;
  classNames?: { root?: string; container?: string; children?: string };
  hideSideBar?: boolean;
  analytics?: ILayoutAnalytics;
}

const SubPageLayout: FC<PropsWithChildren<ISubPageLayoutProps>> = ({
  title,
  children,
  showHamiBalance = false,
  hasPaddingX = true,
  hasCardHeaderBorder,
  hintComponent,
  showSupportButtonOnMobile,
  showSupportButtonOnDesktop,
  hiddenStoryContainer = false,
  isHeaderSticky = true,
  isContentFixed = false,
  classNames,
  analytics,
}) => {
  return (
    <>
      <ThemeHeader />
      <div
        className={classnames(
          'flex min-h-full flex-col bg-[#fff] md:bg-[transparent] md:!p-0',
          isContentFixed && 'md:relative md:max-h-[calc(100vh-160px)]',
          classNames?.root
        )}
      >
        {showHamiBalance && (
          <Hidden down="md">
            <div className="mb-5">
              <HamiBalanceSlide />
            </div>
          </Hidden>
        )}
        <Card
          className={classnames(
            'flex h-full min-h-full w-full flex-grow flex-col !p-0 !py-4 md:flex-grow-0',
            classNames?.container
          )}
        >
          <CardBackHeader
            analytics={analytics}
            hasCardHeaderBorder={hasCardHeaderBorder}
            hiddenStoryContainer={hiddenStoryContainer}
            hintComponent={hintComponent}
            isHeaderSticky={isHeaderSticky}
            showSupportButtonOnDesktop={showSupportButtonOnDesktop}
            showSupportButtonOnMobile={showSupportButtonOnMobile}
            title={title}
          />
          <div
            className={classnames(
              'flex flex-grow flex-col',
              isContentFixed && 'md:overflow-y-auto',
              hasPaddingX && 'px-5',
              classNames?.children
            )}
            id="mainContentChildren"
          >
            {children}
          </div>
        </Card>
      </div>
    </>
  );
};

export default SubPageLayout;
